var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456-384q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-144q0-10.2 6.9-17.1 6.9-6.9 17.1-6.9h96q10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v144q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-96Zm24-48h48v-96h-48v96Zm192 120v-72q0-10.2 6.9-17.1 6.9-6.9 17.1-6.9h72v-24h-73.33q-9.67 0-16.17-6.5-6.5-6.5-6.5-17.42 0-10.08 6.5-17.08 6.5-7 17.81-7H792q9.78 0 16.39 7 6.61 7 7.61 17v72q1 10-6.19 17-7.18 7-17.81 7h-72v24h72q9.6 0 16.8 7.2 7.2 7.2 7.2 16.8 0 11-7.2 17.5T792-288h-96q-11 0-17.5-6.5T672-312Zm-456-72q-11 0-17.5-6.5T192-408v-144q0-10.2 6.5-17.1Q205-576 216-576h96q10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v25q0 9.52-7.2 16.26Q321.6-504 312-504q-11 0-17.5-6.5T288-528h-48v96h48q0-9.6 6.5-16.8 6.5-7.2 17.42-7.2 10.08 0 17.08 7.2 7 7.2 7 16.8v24q0 11-6.9 17.5T312-384h-96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.f2bcd3e79a720f3b12d90464bbbf8648.svg";
export { ForwardRef as ReactComponent };